import { OperationHistoryTemplate } from "@edp-models/operation-history.model";

export interface IOperationsState {
    operations: OperationHistoryTemplate[];
}

export const initialOperationsState: IOperationsState = {
    operations: [],
};
